import { Button } from "@/components/ui/button";
import { useLanguage } from "@/lib/i18n/LanguageContext";

export function LanguageToggle() {
  const { language, setLanguage } = useLanguage();

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={() => setLanguage(language === "en" ? "et" : "en")}
      className="w-16 bg-white"
    >
      {language === "en" ? "🇺🇸" : "🇪🇪"}
    </Button>
  );
}
